import React, { Component } from 'react';
import './StepHeadline.css'

const StepHeadline = (props) => {
	// since on mobile its complatly diffrent layout ,
	// so w're going to show diffrent markup for desktop and mobile

	return (
		<div className="StepHeadline-section">
			{props.Title && <h4 tabIndex="0" className="StepHeadline--title" dangerouslySetInnerHTML={{ __html: (props.Title) }}></h4>}


			{props.SubTitle && <p tabIndex="0" className="StepHeadline--subtitle" dangerouslySetInnerHTML={{ __html: (props.SubTitle) }}></p>
			}
		</div>
	);

}

export default StepHeadline;
